import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";

const ThemeContext = createContext({ theme: "light", toggle: () => {} });

const storageKey = (userId) => `pharmaroute:theme:${userId || "guest"}`;

export const ThemeProvider = ({ children }) => {
  const { user } = useAuth();
  const [theme, setTheme] = useState(() => {
    try {
      const stored = localStorage.getItem(storageKey(null)) || localStorage.getItem("pharmaroute:theme:guest");
      return stored === "dark" || stored === "light" ? stored : "light";
    } catch (_) {
      return "light";
    }
  });

  // When user logs in, restore their per-user preference
  useEffect(() => {
    try {
      const key = storageKey(user?.id);
      const stored = localStorage.getItem(key);
      if (stored === "dark" || stored === "light") setTheme(stored);
    } catch (_) {}
  }, [user?.id]);

  // Apply / unapply the .dark class on <html>
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      try { localStorage.setItem(storageKey(user?.id), next); } catch (_) {}
      return next;
    });
  }, [user?.id]);

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
